import React from 'react';
import styles from './LinksRow.scss';

const LinksRow = ({data}) => {

	if (!data) {
		return null;
	}

	return (
	  <div className={styles.holder}>
		  {data.categories && data.categories.map((item, key) => {
			  return (
				<div className={styles.container} key={key}>
					{item.title && <div>{item.title}:</div>}

					{item.content && item.content.map((itemLink, keyLink) => {
						return (
						  <div className={styles.holder} key={keyLink}>
							  {/*<div className={styles.icon}>*/}
							  {/*  <img src={item.icon} alt={item.iconAlt}/>*/}
							  {/*</div>*/}
							  <div
								className={styles.text}
								dangerouslySetInnerHTML={{__html: itemLink.link}}>
							  </div>
						  </div>
						);
					})}
				</div>

			  );
		  })}
	  </div>
	);
}

export default LinksRow;
